import {
  get,
} from '.';

// eslint-disable-next-line import/prefer-default-export
export const searchSpecies = query =>
  get('species', { params: { q: query } });
